<script>
    export let label = 'Link'
</script>

<style>
    .SidepanelButton {
        display: block;
        width: 100%;
        color: var(--forge-primary-fg);
        text-decoration: none;
        padding: 0 15px;
        line-height: 28px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        background-color: unset;
        text-align: left;
        border-radius: 3px;
    }
    .SidepanelButton:hover {
        background-color: var(--sidelink-hover)
    }
</style>

<button class="SidepanelButton" on:click|stopPropagation>
    <slot>{label}</slot>
</button>